import { Injectable } from '@angular/core';
import { GenericResponse } from './../../../../Autofacets-Core/src/app/business-entities/generic-response.class';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';
import { NotificationRequestViewModel } from '../business-entities/notification-details-result-view-model';

@Injectable({ providedIn: 'root' })
export class DashboardDataService {
    constructor(
        private dataProvider: DataService
    ) {}

    getCardCounts(model:any): Promise<GenericResponse<any>> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.GetCardCount,model).toPromise();
    }

    getDealers(userId: string): Promise<GenericResponse<any>>{
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetDealers,userId).toPromise();
    }
    getNotifications(requestModel:NotificationRequestViewModel): Promise<GenericResponse<any>>{
        return this.dataProvider.Post<GenericResponse<any>>(Urls.GetNotifications,requestModel).toPromise();
    }
    markAllAsRead(userId: string): Promise<GenericResponse<any>>{
        return this.dataProvider.Get<GenericResponse<any>>(Urls.NotificationMarkAllAsRead,userId).toPromise();
    }
    markAsRead(userId: string,id:number): Promise<GenericResponse<any>>{
        return this.dataProvider.Get<GenericResponse<any>>(Urls.NotificationMarkAsRead,userId,id).toPromise();
    }
    getCallHistory(model: any): Promise<GenericResponse<any>>{
        return this.dataProvider.Post<GenericResponse<any>>(Urls.GetCallHistory,model).toPromise();
    }
    getCallerVehicle(customerId: number): Promise<GenericResponse<any>>{
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetCallerVehicle,customerId).toPromise();
    }
    saveCallNote(model: any): Promise<GenericResponse<any>>{
        return this.dataProvider.Post<GenericResponse<any>>(Urls.SaveCallNote, model).toPromise();
    }
    callDial(model: any): Promise<GenericResponse<any>>{
        return this.dataProvider.Post<GenericResponse<any>>(Urls.CallDial, model).toPromise();
    }
    callTransfer(model: any): Promise<GenericResponse<any>>{
        return this.dataProvider.Post<GenericResponse<any>>(Urls.CallTransfer, model).toPromise();
    }
    callHangup(model: any): Promise<GenericResponse<any>>{
        return this.dataProvider.Post<GenericResponse<any>>(Urls.CallHangup, model).toPromise();
    }
    getSyncCounts(): Promise<GenericResponse<any>> {
        return this.dataProvider.GetAll<GenericResponse<any>>(Urls.GetSyncCount).toPromise();
    }
    getBrandWiseAppointment(model: any){
        return this.dataProvider.Post<any>(Urls.GetBrandWiseAppointment, model).toPromise();
    }
    getDealerWithNoAppointments(selectedDate: string): Promise<GenericResponse<any>>{
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetDealerWithNoAppointments,selectedDate).toPromise();
    }
}